<template>
  <div class="common-page telephone-order-record">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="订单编号:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主姓名:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="手机号码:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主归属:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="当天存在下单记录:" prop="orderRecord">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderRecord"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.orderRecordOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button
                  type="primary"
                  round
                  icon="el-icon-search"
                  @click="handleCheck()"
                ></el-button>
                <el-button
                  type="default"
                  round
                  icon="el-icon-refresh"
                  @click="handleReset()"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange"
      >
        <template v-slot:returnMethod="{ row }">
          <span>不存在</span>
          <!--          <span>存在</span>-->
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { downloadTable, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getTree } from "@/views/commonApi";

export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        keyword: "",
        startTime: "",
        deptId: "",
        deptIds: [],
        endTime: "",
        sourceType: "1",
      },
      deptList: [],
      isImmediatelyGetData: false,
      tableColumn: [
        {
          label: "操作时间",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "货主归属",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "货主名称",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "当天存在下单记录",
          prop: "orderNo",
          align: "left",
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.telephone-order-record {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-table-box {
    padding-top: 0;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
